import { Typography } from '@mui/material';
import { isNotNullOrUndefined, isPositive } from '@vy/utils';
import { useEffect, useRef, useState } from 'react';
import { TimelineTick } from './contract-phases-timeline-utils/build-timeline-axis';
import { MIN_TICK_WIDTH } from './contract-phases-timeline-consts';

type ContractPhasesMonthColumnProps = {
  containerWidth: number;
  containerHeight: number;
  ticks: TimelineTick[];
  totalMonths: number;
  monthsPerTick: number;
  renderData?: (dataContainerHeight: number, pixelsPerMonth: number) => React.ReactNode;
};

export const ContractPhasesMonthColumns: React.FC<ContractPhasesMonthColumnProps> = ({
  containerWidth,
  containerHeight,
  ticks,
  totalMonths,
  monthsPerTick,
  renderData,
}) => {
  const fitPixelsPerMonth = isPositive(totalMonths) ? containerWidth / totalMonths : 0;
  const minPixelsPerMonth = MIN_TICK_WIDTH / monthsPerTick;
  const pixelsPerMonth = Math.max(fitPixelsPerMonth, minPixelsPerMonth);
  const fullWidth = pixelsPerMonth * totalMonths;

  const dataContainerRef = useRef<HTMLDivElement>(null);
  const [dataContainerHeight, setDataContainerHeight] = useState(containerHeight);

  useEffect(() => {
    if (isNotNullOrUndefined(dataContainerRef.current)) {
      setDataContainerHeight(dataContainerRef.current.offsetHeight);
    }
  }, [dataContainerRef]);

  return (
    <div
      style={{
        width: `${fullWidth}px`,
      }}
      className="flex border-y border-gray"
    >
      <div ref={dataContainerRef} className="relative">
        {renderData?.(dataContainerHeight, pixelsPerMonth)}
      </div>
      {ticks.map((tick, index) => (
        <div
          key={`${tick.label}-${index}`}
          className="flex flex-row items-end justify-between"
          style={{ width: `${tick.months * pixelsPerMonth}px`, height: `${containerHeight}px` }}
        >
          {index === 0 && <div className="border-l h-full border-gray" />}
          <Typography
            sx={{
              width: "100%",
              paddingBottom: 1,
              fontWeight: 400,
              fontSize: '13px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              overflow: 'visible'
            }}>
            {tick.label}
          </Typography>
          <div className="border-r h-full border-gray" />
        </div>
      ))}
    </div>
  );
};
